export default {
    auth: {
        attendance_success: "📅 Contrôle de présence terminé ! (Daily Rewards)\nBonus du jour +50 points reçu !",
        signup_bonus: "Inscription réussie ! 🎉\nBonus de bienvenue +100 points reçu !",
        referral_bonus: "Inscription par invitation terminée ! 🤝\nBonus de bienvenue 100P + Bonus parrainage 500P\nTotal 600 points reçus !",
        login_required: "Connexion requise"
    },
    social: {
        subscribe_on: "Ajouté à la liste d'abonnements.",
        subscribe_off: "Abonnement annulé.",
        like_on: "J'aime !",
        like_off: "J'aime retiré.",
        follow_on: "Suivi.",
        follow_off: "Suivi annulé."
    },
    comment: {
        submit_success: "Commentaire publié.",
        delete_confirm: "Êtes-vous sûr de vouloir supprimer ?",
        delete_success: "Supprimé.",
        delete_error: "Erreur de suppression",
        submit_error: "Erreur de publication du commentaire",
        empty_error: "Veuillez saisir du contenu."
    },
    payment: {
        verify_success: "Vérification terminée !\n{amount} Étoiles rechargées.",
        verify_fail: "Erreur de vérification",
        user_cancel: "Paiement annulé.",
        error: "Erreur de paiement"
    },
    common: {
        confirm: "Confirmer",
        cancel: "Annuler",
        close: "Fermer",
        save: "Enregistrer",
        delete: "Supprimer",
        edit: "Modifier",
        copy: "Copier",
        loading: "Chargement...",
        error: "Une erreur est survenue.",
        success: "Réussi.",
        webtoon: "Webtoon",
        webnovel: "Webroman",
        cinenovel: "Ciné-Roman",
        published: "Publié",
        draft: "Brouillon",
        editor: "Éditeur"
    },
    seo: {
        default_title: "Mirinae Platform - Where Imagination Becomes Reality",
        default_desc: "Next-gen Webtoon/Webnovel platform combining AI and Art. Become an author and create your own universe."
    },
    footer: {
        terms: "Conditions d'utilisation",
        privacy: "Politique de confidentialité",
        report: "Centre de réclamation",
        biz_ceo: "PDG",
        biz_addr: "Adresse",
        biz_tel: "Support",
        biz_email: "Email",
        biz_license: "Licence",
        biz_mail_order: "E-Commerce",
        biz_none: "Pas d'info",
        system_ready: "SYSTEM READY",
        copyright: "SSULWHA WORLD"
    },
    menu: {
        home: "Accueil",
        webtoon: "Webtoon",
        webnovel: "Webroman",
        novel: "Webroman",
        davinci: "Da Vinci",
        studio: "Studio Créateur",
        library: "Bibliothèque",
        support: "Support",
        admin: "Admin",
        config: "Liens externes",
        factory: "Popups & Notifications",
        docs: "Éditeur de documents",
        analytics: "Analyse des tendances",
        plaza: "Club Ssulwha",
        wisdom: "Sagesse des Étoiles",
        recommendation: "Étagère vide",
        charge: "Station Stellaire",
        guide: "Guide",
        "whats-new": "Quoi de neuf",
        invite: "Inviter des amis",
        about: "À propos du service",
        terms: "Conditions d'utilisation",
        privacy: "Politique de confidentialité",
        report: "Centre de réclamation",
        "app-setting": "Paramètres de l'app",
        login: "Connexion / Inscription",
        logout: "Déconnexion",
        MyPage: "Ma Page",
        notice: "Annonces",
        proposal: "Proposition",
        settings: "Paramètres",
        language: "Langue"
    },
    modal: {
        translate_title: "Choix de la langue",
        translate_placeholder: "Veuillez choisir une langue à traduire.",
        translate_start: "Traduire"
    },
    msg: {
        welcome_beta: "Bienvenue sur la version Bêta de Mirinae.",
        login_required: "Connectez-vous pour débloquer plus d'histoires.",
        login_btn: "Connexion / Inscription"
    },
    profile: {
        follow: "Suivre",
        following: "Abonné",
        mypage: "Ma Page",
        followers: "Abonnés",
        following_count: "Abonnements",
        bio_empty: "Pas de présentation.",
        works: "Œuvres",
        feed: "Fil d'actu",
        guestbook: "Livre d'or",
        works_empty: "Aucune œuvre enregistrée.",
        works_error: "Échec du chargement des œuvres",
        feed_empty: "Aucune publication.",
        feed_error: "Échec du chargement du fil.",
        feed_error_detail: "Création d'index en cours ou erreur réseau.",
        follow_error: "Échec de l'action de suivre."
    },
    support: {
        title: "Centre de Support 1:1",
        input_placeholder: "Entrez votre demande...",
        empty_state_title: "Aucun historique de consultation.",
        empty_state_desc: "Posez-nous vos questions à tout moment !",
        status_received: " • Reçu",
        auto_reply: "Votre demande a été reçue. Nous répondrons séquentiellement. En attendant, profitez de Ssulwha World.",
        send_fail: "Échec de l'envoi du message"
    },
    author: {
        apply_title: "Candidature Auteur",
        apply_desc: "Partagez votre histoire avec le monde. Laissez une brève présentation et un portfolio, nous vous contacterons après examen.",
        email_label: "E-mail",
        email_placeholder: "Entrez l'e-mail de contact",
        email_hint: "Nous pouvons vous contacter concernant les résultats d'approbation et les contrats.",
        intro_label: "Présentation",
        intro_placeholder: "Veuillez vous présenter (Expérience d'écriture, style, etc.)",
        portfolio_label: "Portfolio (Optionnel)",
        submit_btn: "Postuler",
        email_required: "Veuillez entrer votre e-mail.",
        intro_required: "Veuillez entrer votre présentation.",
        submitting: "Envoi en cours...",
        submit_success: "Candidature auteur envoyée."
    },
    point: {
        reason: {
            attendance: "Daily Attendance",
            reading: "Reading Reward",
            reading_reward: "Reading Reward",
            welcome: "Welcome Reward",
            referral: "Referral Reward",
            author_apply: "Author Application",
            rental: "Rental",
            purchase: "Purchase"
        }
    },
    wallet: {
        tab_title: "Wallet",
        sub_card: {
            upgrade_btn: "Upgrade Membership (₩{price}/mo)",
            coming_soon: "Coming Soon",
            tier_label: "Membership Tier",
            tier_premium: "Premium Pass",
            tier_standard: "Standard Member",
            renews_on: "Renews on"
        },
        assets: {
            activity_label: "Activity Points",
            activity_desc: "Free Earned Points",
            star_label: "Star Points",
            star_desc: "Paid Charged Points"
        },
        charge: {
            title: "Star Station",
            desc: "Charge needed stars"
        },
        history: {
            title: "Point History",
            empty: "No history found."
        }
    },
    history: {
        empty: {
            title: "No history yet.",
            desc: "Shall we explore some works?",
            action_btn: "Go Explore"
        },
        common: {
            no_title: "No Title"
        },
        last_viewed: "Last viewed:",
        episode_fmt: "Ep. {n}",
        delete_confirm: {
            msg: "Do you want to delete this history?",
            title: "Delete History"
        }
    },
    library: {
        empty_title: "La bibliothèque est vide",
        empty_desc: "Les œuvres achetées ou consultées apparaîtront ici.",
        explore_btn: "Explorer les œuvres",
        select_hint: "Sélectionnez une œuvre pour voir la liste.",
        total_episodes: "Total {n} épisodes"
    },
    badge: {
        best_reviewer: "Meilleur Critique",
        top_author: "Meilleur Auteur",
        vip: "VIP",
        donation_king: "Roi des Dons",
        hall_of_fame: "Temple de la Renommée"
    },
    tab: {
        works: "Œuvres",
        feed: "Ssulwha (Feed)",
        guestbook: "Livre d'or"
    },
    tag: {
        fantasy: "Fantaisie",
        romance: "Romance",
        martial_arts: "Arts martiaux",
        drama: "Drame",
        slice_of_life: "Tranche de vie",
        comedy: "Comédie",
        thriller: "Thriller",
        school: "École",
        munchkin: "Munchkin",
        regression: "Régression",
        possession: "Possession",
        system: "Système",
        growth: "Croissance",
        revenge: "Vengeance",
        heart: "Cœur",
        horror: "Horreur",
        sport: "Sport",
        history: "Histoire Alt."
    },
    guestbook: {
        title: "Livre d'or",
        input_placeholder: "Laissez un message de soutien !",
        secret: "Secret",
        submit: "Envoyer",
        empty: "Soyez le premier à laisser un message ! 👣",
        secret_content: "Ceci est un message secret.",
        delete_confirm: "Êtes-vous sûr ?",
        reply: "Répondre",
        reply_placeholder: "Écrire une réponse...",
        reply_delete_confirm: "Supprimer la réponse ?",
        confirm_delete_reply: "Supprimer cette réponse ?",
        submit_error: "Échec de l'envoi : ",
        emoji_error: "Échec du chargement des émojis"
    },
    pwa: {
        install_title: "Installer",
        install_desc: "Expérience plus rapide et meilleure.",
        install_btn: "Installer",
        later_btn: "Plus tard",
        ios_guide_title: "Installer sur iPhone",
        ios_guide_desc: "Profitez de la meilleure expérience en plein écran.",
        ios_step1: "Appuyez sur 'Partager'",
        ios_step2: "Sélectionnez 'Sur l'écran d'accueil'",
        update_title: "Nouvelle version ({version}) !",
        update_title_v2: "Une nouvelle version est disponible !",
        update_desc: "Mettez à jour pour les nouvelles fonctionnalités.",
        update_btn: "Mettre à jour",
        updating: "Mise à jour...",
        offline_title: "Vous êtes hors ligne",
        offline_desc: "Veuillez vérifier votre connexion internet.",
        copy_success: "Copié",
        copy_fail: "Échec de la copie"
    },
    settings: {
        title: "Paramètres de l'App",
        general: "Général",
        push_title: "Notifications Push",
        push_desc: "Recevoir les notifications de mise à jour",
        app_info: "Infos sur l'Appli",
        current_version: "Version Actuelle",
        danger_zone: "Zone de Danger",
        delete_account_title: "Supprimer le Compte (Retour à la Réalité)",
        delete_account_desc: "Toutes les données seront supprimées et ne pourront pas être récupérées.",
        delete_account_button: "Retour à la Réalité"
    },
    proposal: {
        title: "Sagesse des Étoiles",
        desc: "Votre sagesse éclatante élargit l'univers.",
        label_title: "Titre de la proposition",
        placeholder_title: "Entrez l'essence de votre idée",
        label_content: "Détails",
        placeholder_content: "Partagez vos idées librement. Plus c'est concret, mieux c'est !",
        btn_submit: "Envoyer la Sagesse",
        success_title: "Sagesse Reçue",
        success_desc: "La sagesse de {name} a été enregistrée.<br>Merci pour vos précieux commentaires."
    },
    report: {
        title: "Centre de réclamation",
        category_label: "CATÉGORIE",
        content_label: "CONTENU",
        url_label: "URL ASSOCIÉE",
        categories: {
            general: "Question générale / Autre",
            spam: "Spam / Publicité inappropriée",
            abuse: "Insulte / Discours haineux",
            adult: "Contenu adulte / Nocif pour les mineurs",
            bug: "Erreur système / Bug"
        },
        placeholder_content: "Veuillez décrire le problème en détail.",
        btn_submit: "Soumettre une plainte",
        warning: "Les fausses plaintes peuvent entraîner des restrictions de service.",
        success_title: "Plainte envoyée",
        success_desc: "Nous examinerons et agirons rapidement.<br>Merci pour votre signalement.",
        login_required: "Vous devez être connecté pour signaler.",
        submit_success: "Plainte soumise avec succès.\nVeuillez vérifier dans le centre d'administration...",
        error: "Erreur lors de l'envoi de la plainte",
        modal: {
            title: "Report",
            desc: "Please select a reason. False reports may result in service restrictions.",
            category: "Category",
            detail: "Detail",
            url: "Related URL",
            submit: "Submit",
            cancel: "Cancel"
        },
        reason: {
            spam: "Spam / Promotion",
            abusive: "Abusive Language",
            inappropriate: "Inappropriate Content",
            other: "Other / Inquiry"
        }
    },
    guide: {
        title: "Paramètres système",
        desc: "Nous ajustons la boussole<br>pour vous aider dans votre voyage.",
        wait: "Veuillez patienter."
    },
    viewer: {
        settings_title: "Paramètres Audio/Défilement",
        bgm_volume: "Volume BGM",
        bgm_off: "BGM Off",
        auto_speed: "Vitesse auto",
        settings_btn: "Paramètres",
        translate_btn: "Traduction IA",
        tts_btn: "Lecture TTS",
        bgm_btn: "BGM",
        top_btn: "Haut",
        auto_play: "Auto-Slide",
        auto_scroll: "Auto-Scroll",
        start_auto: "Auto-Play",
        stop_auto: "Arrêté",
        tts_warn: "Note : TTS lit dans la langue originale (Coréen)."
    },
    login: {
        subtitle: "Où votre imagination devient réalité",
        btn_google: "Continuer avec Google",
        or: "OU",
        label_email: "Email",
        label_password: "Mot de passe",
        btn_email_login: "Connexion par Email",
        btn_email_signup: "Inscription par Email",
        msg_no_account: "Pas de compte ?",
        msg_has_account: "Déjà un compte ?",
        btn_signup: "S'inscrire",
        btn_login: "Se connecter",
        msg_processing: "Traitement...",
        msg_email_sent: "Email de vérification envoyé. Veuillez vérifier et vous connecter.",
        err_invalid_auth: "Email ou mot de passe invalide.",
        err_email_in_use: "L'email est déjà utilisé.",
        err_default: "Une erreur est survenue."
    },
    terms: {
        title: "Contrôle d'immigration",
        desc: "Bienvenue dans le monde SSULWHA.<br>Veuillez accepter les conditions d'utilisation.",
        required: "[Requis]",
        optional: "[Optionnel]",
        label_terms: "Conditions de service",
        label_privacy: "Politique de confidentialité",
        label_marketing: "Consentement marketing",
        btn_start: "Commencer",
        btn_processing: "Traitement..."
    },
    main: {
        banner_welcome: "✨ Explorez le monde SSULWHA aujourd'hui !",
        search_placeholder: "Rechercher œuvres, auteurs, tags...",
        hall_of_fame: "Temple de la Renommée (Weekly Best)",
        hall_of_fame_locked: "Le Temple de la Renommée est réservé aux membres",
        hall_of_fame_desc: "Qui est l'utilisateur le plus actif cette semaine ? Connectez-vous pour voir le classement !",
        login_btn: "Se connecter",
        todays_pick: "Choix du jour",
        continue_reading: "Continuer la lecture",
        trending: "Tendances",
        new_arrivals: "Nouveautés",
        all_works: "Toutes les œuvres",
        tag_cloud: "Par tags",
        filter_all: "Tout",
        filter_webtoon: "Webtoon",
        filter_webnovel: "Webroman",
        realtime_club: "Club Ssulwha en temps réel",
        enter_club: "Entrer",
        be_the_first: "Lancez la première étoile !",
        go_to_plaza: "Aller à la Place",
        search_results: "Résultats de recherche : '{query}'",
        search_no_results: "Aucun résultat trouvé.",
        search_try_other: "Essayez d'autres mots-clés.",
        splash_loading: "Entrée dans le monde Ssulwha...",
    },
    mypage: {
        tab_library: "Bibliothèque",
        tab_history: "Historique",
        tab_activity: "Activité",
        tab_likes: "Favoris",
        tab_wallet: "Portefeuille",
        tab_settings: "Paramètres",
        no_activity: "Aucune activité.",
        go_to_plaza: "Aller à la Place",
        followers: "Abonnés",
        following: "Abonnements",
        edit_profile_tooltip: "Éditer profil",
        role_author: "Auteur",
        role_reader: "Lecteur",
        role_admin: "Admin",
        author_pending: "⏳ En attente d'approbation",
        btn_studio: "Studio Créateur",
        btn_apply_author: "Devenir Auteur",
        default_bio: "Entrez une courte présentation.",
        menu_edit_profile: "Modifier le profil",
        menu_public_profile: "Profil public",
        current_version: "Version actuelle",
        invite_title: "Inviter des amis",
        invite_reward: "Récompense +500P",
        invite_desc: "Partagez le lien. Vous et votre ami recevez chacun 500P !",
        invited_count: "Amis invités",
        unit_people: "pers.",
        edit_profile_title: "Modification du profil",
        label_photo: "Photo de profil",
        btn_upload: "Télécharger",
        btn_random: "Aléatoire",
        placeholder_photo_url: "Ou URL de l'image",
        label_nickname: "Surnom",
        label_bio: "Bio",
        placeholder_bio: "Courte présentation sur vous-même"
    },

    plaza: {
        title: "Club Ssulwha",
        subtitle: "Espace de communication émotionnelle pour la génération Z",
        btn_sync: "⚡ Sync Commentaires (Admin Only)",
        composer_placeholder_init: "Quelle histoire voulez-vous lancer dans cet univers ?",
        composer_placeholder_thread: "Écrivez la suite de l'histoire...",
        composer_placeholder_quote: "Laissez vos pensées sur cette histoire...",
        btn_add_thread: "Ajouter un fil",
        btn_submit: "Lancer l'étoile",
        btn_submit_quote: "Citer",
        btn_submitting: "Chargement...",
        quote_suffix: " a cité"
    },
    recommendation: {
        loading_title: "Lecture de votre trajectoire...",
        loading_desc: "Connexion de vos pas passés et des étoiles où vous vous êtes arrêté",
        fallback_title: "La constellation de <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span><br>est encore faible.",
        fallback_desc: "Mais ne vous inquiétez pas. <br>Nous avons sélectionné des histoires brillantes qui ont illuminé les nuits de beaucoup d'autres.<br><span class=\"text-sm opacity-70 mt-1 block\">À mesure que vos empreintes augmentent, nous trouverons une orbite rien que pour vous.</span>",
        personal_title: "Étagère de <span class=\"text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-200 to-amber-200\">{name}</span>,<br>Histoire pour le prochain emplacement",
        personal_desc: "Nous avons trouvé 5 étoiles qui résonnent avec vos goûts.",
        label_empty_shelf: "Étagère vide (The Empty Shelf)",
        btn_refresh: "Autres recommandations",
        error_title: "Connexion instable",
        btn_retry: "Réessayer",
        empty_data_title: "Données insuffisantes",
        btn_browse: "Parcourir les œuvres",
        widget_title: "Vous cherchez le<br>prochain livre ?",
        widget_desc: "Nous avons sélectionné 5 œuvres basées sur les goûts de {name}.",
        widget_desc_guest: "Nous avons sélectionné 5 œuvres basées sur vos goûts.",
        btn_check: "Voir maintenant"
    },
    star_station: {
        title: "Station Stellaire",
        subtitle: "Profitez des œuvres plus librement.",
        my_stars: "Mes Étoiles",
        history_tab: "Historique",
        products_tab: "Produits",
        payment_method: "Moyen de paiement",
        btn_charge: "Recharger",
        history_empty: "Aucun historique de recharge.",
        product_names: {
            stardust: "Poussière d'étoile",
            shooting_star: "Étoile filante",
            little_bear: "Petite Ourse",
            silver_river: "Rivière d'argent",
            galaxy_master: "Maître Galactique",
            star_maker: "Faiseur d'étoiles"
        }
    },
    studio: {
        title: "Studio Créatif",
        desc: "Espace pour votre imagination infinie.",
        dashboard: "Tableau de bord",
        series: "Gestion des Séries",
        statistics: "Statistiques",
        profit: "Revenus",
        guide: "Guide de l'auteur",
        new_series: "Nouvelle Série",
        edit_series: "Modifier la Série",
        new_episode: "Nouvel Épisode",
        edit_episode: "Modifier l'Épisode",
        open_menu: "Ouvrir le menu",
        exit: "Quitter",
        lab_badge: "LAB",
        lab_title: "Laboratoire Da Vinci",
        lab_desc: "Ouvrez un nouveau monde de création avec l'IA.",
        total_views: "Vues",
        total_likes: "J'aime",
        total_followers: "Abonnés",
        weekly_performance: "Performance Hebdomadaire",
        views_trend_7d: "Tendance des Vues (7 jours)",
        live_data: "EN DIRECT",
        my_series_list: "Mes Œuvres",
        total_series_count: "Total {n} œuvres",
        empty_series_title: "Commencez une nouvelle histoire",
        empty_series_desc: "Déployez votre imagination dans le monde.",
        btn_editor: "Éditeur",
        btn_settings: "Paramètres",
        btn_delete: "Supprimer",
        delete_modal_title: "Supprimer la série",
        create_first_episode: "Créez votre premier épisode !",
        create_first_episode_desc: "Cliquez sur le bouton Nouvel Épisode pour commencer.",
        last_updated: "Dernière mise à jour : {date}",
        delete_episode_title: "Supprimer l'épisode",
        delete_episode_content: "Êtes-vous sûr de vouloir supprimer l'épisode '{title}' ?",

        // Toolbar
        bold: "Gras",
        italic: "Italique",
        highlight_red: "Surligner (Rouge)",
        highlight_blue: "Surligner (Bleu)",
        save_preserve_status: "Enregistrer (Garder le statut)",
        delete_modal_content: "Êtes-vous sûr de vouloir supprimer '{title}' ? Cette action est irréversible."
    },
    editor: {
        davinci_editor: "Éditeur DaVinci",
        webnovel_editor: "Éditeur Webroman",
        webtoon_editor: "Éditeur Webtoon",
        episode_title: "Titre de l'épisode",
        placeholder_title: "Entrez le titre de l'épisode",
        content: "Contenu",
        placeholder_content: "Écrivez votre histoire ici...",
        author_note: "Note de l'auteur",
        placeholder_note: "Un mot pour vos lecteurs...",
        upload_image: "Télécharger Image",
        upload_cover: "Télécharger Couverture",
        save_draft: "Enregistrer brouillon",
        publish: "Publier",
        ai_analysis: "Analyse IA",
        ai_recommend: "Recommandation IA",
        tags: "Tags",
        placeholder_tags: "Ajouter des tags (séparés par des virgules)",
        preview: "Aperçu",
        settings: "Paramètres",
        episode_prefix: "Épisode",
        draft_mode_title: "Mode Brouillon",
        draft_mode_private_desc: "Cet épisode est actuellement masqué.",
        display_mode: "Mode d'affichage",
        mode_webtoon: "Webtoon (Défilement)",
        mode_comic: "Comic (Page)",
        mode_insta: "InstaToon",
        mode_desc: "Optimise l'expérience de visionnage.",
        thumbnail: "Miniature",
        bgm: "BGM",
        manuscript_images: "Manuscrit",
        drag_drop_hint: "Glissez-déposez des images ou Appuyez pour télécharger",
        set_draft: "En Brouillon",
        save_changes: "Enregistrer les modifications",
        live_preview: "Aperçu en direct",
        preview_hint: "Vérifiez l'apparence sur mobile.",
        val_webtoon_error: "[Erreur Mode Webtoon] Image trop large (Ratio : {ratio}).<br>Le mode Webtoon nécessite un défilement vertical (Hauteur > Largeur * 1.2).<br>Pour les pages simples, veuillez utiliser le mode 'Comic'.",
        val_comic_error: "[Erreur Mode Comic] Ratio d'aspect invalide ({ratio}).<br>Formats autorisés :<br>- Page verticale (env. 2:3 à 3:4)<br>- Double page horizontale (Largeur > Hauteur)<br><br>Les longues bandes de défilement doivent utiliser le mode 'Webtoon'.",
        val_insta_error: "[Erreur InstaToon] Ratio d'aspect invalide ({ratio}).<br>L'optimisation pour Instagram nécessite un Carré (1:1) ou Portrait (4:5).<br>L'image actuelle est trop large ou trop haute.",
        approval_requested: "Approbation demandée",
        approval_desc: "Votre travail a été soumis pour approbation.\\nIl sera publié après examen par l'administrateur.",
        pending_approval: "En attente d'approbation",
        saved_to_draft: "Enregistré en brouillon",
        published_start_ai: "Épisode publié ! Lancement de l'analyse IA...",
        ai_trigger_fail: "Le lancement de l'analyse IA a échoué. Veuillez utiliser le bouton 'Analyse IA' manuellement.",
        save_failed: "Échec de l'enregistrement : {e}",
        upload_complete: "Téléchargement terminé",
        upload_fail_desc: "Échec du téléchargement de l'image. (Échec de génération d'URL)\nVeuillez vérifier les logs de la console.",
        image_mode_mismatch: "L'image sélectionnée ne correspond pas aux spécifications du mode {mode}.",
        invalid_format: "Format Invalide",
        mode_change_blocked: "Changement de Mode Bloqué",
        mode_change_blocked_desc: "Certaines images existantes ne correspondent pas aux spécifications {mode}. Veuillez les supprimer et réessayer.",
        processing: "Traitement...",
        tap_nav_hint: "Appuyez sur les bords pour naviguer ou Faites défiler",
        ai_analyze_title: "Confirmer l'analyse IA",
        ai_analyze_confirm: "Lancer l'analyse IA (OCR) sur ces images ?\\nLes données d'analyse existantes seront mises à jour.",
        save_required: "Veuillez d'abord enregistrer l'épisode.",
        ai_requesting: "Demande au serveur IA... (OCR/SEO)",
        ai_processing_title: "Traitement IA",
        ai_no_items: "Aucun élément analysé (0).\\n\\n[Détails]\\n{log}",
        diagnosis_report: "Rapport de diagnostic",
        ocr_complete: "OCR Terminé : {n} images",
        seo_trigger: "Génération SEO auto déclenchée.",
        ai_complete_desc: "Analyse Terminée.\\n- Données OCR Créées\\n- Métadonnées SEO En attente\\n(S'afficheront sous peu)",
        ai_error: "Erreur de traitement IA",
        ai_fail_msg: "Échec de l'analyse IA : {e}",
        title: "Novel Studio",
        master_detail: "Master-Detail View",
        save: "Enregistrer",
        saved: "Enregistré",
        saving: "Enregistrement...",
        complete: "Terminé",
        error: "Erreur",
        ai_analyze_btn: "Analyse IA",
        ai_analyzing: "Analyse...",
        series_info: "Info Série (Upload)",
        series_title: "Titre de la série",
        cover_url: "URL de couverture",
        admin_readonly: "Admin Uniquement (Read Only)",
        chapters: "Liste des chapitres",
        add_chapter: "Ajouter un chapitre",
        delete_chapter_confirm: "Supprimer ce chapitre ?",
        untitled_episode: "Sans titre",
        bgm_label: "BGM (optionnel)",
        content_body: "Contenu",
        load_txt: "Charger TXT",
        text_too_short: "Texte trop court.",
        upload_cover_fail: "Échec du téléchargement de la couverture",
        create_series: "Créer une série",
        edit_series: "Modifier la série",
        basic_info: "Info de base",
        episode_mgmt: "Gestion des épisodes",
        compliance: "Conformité (Compliance)",
        age_rating: "Classification par âge",
        age_guide: "Guide",
        is_ai: "Contenu IA utilisé",
        desc_placeholder: "Entrez la description de l'intrigue...",
        cover_image: "Image de Couverture",

        series_status: "Statut de la Série",
        admin_info: "Info Admin",
        format: "Format",
        publish_now: "Publier",
        format_locked: "Verrouillé",
        webtoon: "Webtoon (Webtoon)",
        webnovel: "Webroman (Webnovel)",
        cinenovel: "Ciné-Roman (Cine-Novel)",
        admin_id: "Code ID (Admin Only)",
        ai_context_analysis_confirm: "Run AI Context Analysis?\n(Existing data will be overwritten)",
        ai_analyzing_background: "Requesting AI Analysis... (Background)",
        ai_no_items_found: "No items analyzed...",
        creating_episode: "Creating New Episode...",
        episode_not_found: "Episode not found.",
        uploading_images_toast: "Uploading images...",
        approval_request_sent: "Approval request sent. (Pending Admin Review)",
        publish_success: "Successfully Published!",
        temp_saved_toast: "Temporarily Saved.",
        deleted_toast: "Deleted.",
        access_denied: "Access Denied",
        series_info_upload: "Series Info (Upload)",
        save_success: "Saved",
        publish_confirm: "Confirm Publish",

        input_title_placeholder: "Enter title",
        ai_analyze_local: "AI Analyze (Local)",

        cancel: "Annuler",
        create: "Créer",
        episode_list: "Liste des épisodes",
        open_editor_fullscreen: "Ouvrir l'éditeur (Plein écran)",
        editor_guide_text: "* Utilisez 'Ouvrir l'éditeur' pour effectuer des modifications.",
        admin_zone: "Zone Admin",
        admin_zone_desc: "Cette information est restreinte.",
        download_csv: "Télécharger CSV (ISBN)",
        adult_confirm_title: "Avertissement 18+",
        adult_confirm_body: "Définir comme 'Adulte (19+)' ?\\n\\n- Bloquera l'accès aux mineurs.\\n- Peut nécessiter une vérification d'identité.",
        davinci_lock_title: "🚧 En développement",
        davinci_lock_desc: "Le mode Da Vinci (Ciné-Roman) est en bêta-test.<br>Accès réservé aux <strong>Administrateurs</strong> en raison de l'instabilité.<br><div class='mt-3 text-rose-400 font-bold'>Bientôt disponible.</div>",
        preview_preparing: "Préparation de l'aperçu...",
        upload_fail: "Échec du téléchargement : Utilisation de l'URL.",
        select_chapter: "Sélectionner un chapitre",
        episode_placeholder: "ex: Ép. 1 Le commencement",
        bgm_placeholder: "URL Suno AI...",
        content_placeholder: "Commencez votre histoire...",
        note_placeholder: "Un mot aux lecteurs...",
        cover_upload_fail: "Erreur couverture : ",
        ai_analysis_fail: "Erreur analyse IA : ",
        save_fail: "Erreur enregistrement : ",
        age_all: "All",
        age_12: "12+",
        age_15: "15+",
        age_19: "19+",
        rating_label: "Rating",
        age_19_desc: "* Selecting 19+ will block minors and require identity verification.",
        age_lock_warning: "Warning: Once saved, authors cannot change this setting. Contact admin for changes.",
        is_ai_desc: "Must be checked if AI-generated images or text are used.",
        publish_settings: "Publish Settings",
        ai_confirm: "AI Confirmation",
    },

    rating_guide: {
        title: "Guide de Classification du Contenu",
        all_title: "Tous Publics",
        all_desc: "Contenu adapté à tous les âges.<br>Pas ou très peu de violence, de contenu sexuel ou de langage inapproprié.",
        title_12: "12+ (Ados)",
        desc_12: "Peut contenir une violence légère, un langage grossier ou de l'horreur.<br>Guidance parentale suggérée pour les enfants de moins de 12 ans.",
        title_15: "15+ (Jeunes Adultes)",
        desc_15: "Peut contenir une violence modérée, un langage fort ou des thèmes matures.<br>Peut dépeindre un comportement criminel ou des tabous sociaux.",
        title_19: "19+ (Adultes Seulement)",
        desc_19: "Contient un contenu sexuel explicite, une violence extrême ou un langage abusif.<br><strong class='text-red-500'>Légalement restreint aux adultes de plus de 19 ans. Vérification d'identité requise.</strong>",
        disclaimer: "* La classification est la responsabilité de l'auteur. Les fausses classifications peuvent entraîner des changements forcés ou des pénalités.",
        confirm: "Compris"
    },
    davinci: {
        episode_settings: "Paramètres de l'épisode",
        title: "Titre",
        thumbnail: "Miniature",
        bgm: "BGM",
        add_block: "Ajouter un bloc",
        text_block: "Texte",
        image_block: "Image",
        upload_image: "Télécharger photo",
        upload_thumb: "Télécharger miniature",
        upload_success: "Téléchargé",
        bgm_placeholder: "URL Suno ou lien MP3",
        tip: "Astuce :",
        drag_tip: "Glissez les blocs pour trier.",
        save_draft: "Enregistrer brouillon",
        publish: "Publier",
        saving: "Enregistrement...",
        published: "Publié ! Visible par les lecteurs.",
        publish_confirm: "Publier maintenant ? Les lecteurs verront ceci.",
        preview_preparing: "Préparation de l'aperçu...",
        thumbnail_uploading: "Téléchargement de la miniature...",
        thumbnail_applied: "Miniature appliquée",
        guide: {
            title: "Guide des Boutons",
            save: "Enregistrer",
            save_desc: "Enregistre les modifications.",
            draft: "Brouillon",
            draft_desc: "Passer en privé.",
            publish: "Publier",
            publish_desc: "Rendre public. (Visible par les lecteurs)",
            auto_save: "Sauve auto",
            auto_save_on: "ON (3s)",
            auto_save_desc: "Sauvegarde automatiquement toutes les 3 secondes."
        }
    },
    intro: {
        slogan: "Créativité Humaine, Évolutivité de l'IA",
        hero_title: "Le Babel Fish",
        hero_subtitle: "pour Ciné-Romans.",
        status_active: "Moteur de Traduction Actif",
        status_cine: "Format Ciné-Roman",
        desc_1: "Lisez instantanément des IP coréennes en <span class='text-white font-bold mx-1'>10 langues</span> avec notre IA non destructive.",
        desc_2: "Découvrez le <span class='text-white font-bold mx-1'>premier format hybride au monde</span> où visuels et romans fusionnent.",
        cta_start: "Commencer à lire gratuitement",
        compare_title: "Destructif vs Non-Destructif",
        compare_desc: "Nous ne touchons jamais aux pixels originaux. Voyez la différence.",
        compare_old: "Ancienne Méthode (Boîte Blanche)",
        compare_new: "Moteur Ssulwha (R.A.P.S)",
        white_box_removed: "Boîtes Blanches Supprimées",
        format_title: "Au-delà des images statiques",
        format_desc: "Visuels de Webtoon. Profondeur de roman. Immersion cinématographique.",
        geo_title: "Croissance pilotée par l'IA",
        geo_desc: "Nous ne faisons pas de marketing. Notre IA le fait.",
        term_log_1: "Analyse du contenu...",
        term_log_2: "Extraction de mots-clés...",
        term_log_3: "Injection de métadonnées JSON-LD...",
        term_log_4: "Croissance organique +300%",

        // Missing Keys Added
        slider_old_title: "Ancienne Méthode",
        slider_old_desc: "BLOQUE L'ART",
        slider_new_title: "Moteur Ssulwha (R.A.P.S)",
        slider_new_desc_1: "\"C'est ainsi que cela devrait être.\"",
        slider_new_desc_2: "Le texte flotte naturellement, préservant l'œuvre d'art.",

        phone_analyzing: "Analyse...",
        phone_detected: "Détecté",
        phone_text_1: "Est-ce mon destin ?",
        phone_cine_ep: "CINÉ-ROMAN EP.01",
        phone_cine_text_1: "Les néons clignotaient, se reflétant dans ses yeux froids.",
        phone_cine_text_2: "\"Ce n'est pas juste une traduction,\" marmonna-t-il. \"C'est une nouvelle réalité.\"",

        footer_copyright: "Propulsé par le moteur R.A.P.S."
    }
};
